// 数据仪表
import type { RouteRecordRaw } from 'vue-router'
import { withAccessKeyMeta } from '@/router/access-map'
import { defaultLayout } from '@/router/base'

const routes: RouteRecordRaw[] = [
  {
    path: '/commission',
    name: 'Commission',
    component: defaultLayout,
    meta: withAccessKeyMeta('commission', {
      locale: 'common.menus.commission',
      requiresAuth: true,
      icon: 'commission',
      hideChildrenInMenu: true,
      activeMenu: 'Commission',
      order: 1,
    }),
    children: [
      {
        path: '',
        name: 'CommissionIndex',
        component: () => import('@/views/commission/index.vue'), // 客户列表
        meta: {
          locale: 'common.menus.commission',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Commission',
          isTopMenu: true,
        },
      },
      {
        path: 'bill-list',
        name: 'CommissionBillList',
        component: () => import('@/views/commission/bill-list.vue'), // 客户列表
        meta: {
          locale: 'common.menus.commission',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Commission',
          isTopMenu: true,
        },
      },
      {
        path: 'detail',
        name: 'CommissionDetail',
        component: () => import('@/views/commission/detail.vue'), // 客户列表
        meta: {
          locale: 'common.menus.commission',
          requiresAuth: true,
          roles: ['*'],
          activeMenu: 'Commission',
          isTopMenu: true,
        },
      },
    ],
  },
]

export default routes
